import React, { useState } from 'react';

const TrainingFormTabs = () => {
    const [activeTab, setActiveTab] = useState('book');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px', minHeight: '100vh' }}>
            {/* Tabs */}
            <div style={{ display: 'flex', gap: '40px', marginBottom: '30px', borderBottom: '1px solid #444' }}>
                <button
                    onClick={() => setActiveTab('book')}
                    style={{
                        border: 'none',
                        borderBottom: activeTab === 'book' ? '2px solid violet' : 'none',
                        background: 'none',
                        color: activeTab === 'book' ? 'pink' : 'gray',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    Book a Trainer
                </button>
                <button
                    onClick={() => setActiveTab('become')}
                    style={{
                        border: 'none',
                        borderBottom: activeTab === 'become' ? '2px solid violet' : 'none',
                        background: 'none',
                        color: activeTab === 'become' ? 'pink' : 'gray',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    Become a Trainer
                </button>
            </div>

            {/* Forms */}
            <div style={{ width: '100%', maxWidth: '800px' }}>
                {activeTab === 'book' ? <BookForm /> : <BecomeForm />}
            </div>
        </div>
    );
};

const inputStyle = {
    backgroundColor: 'white',
    border: '1px solid #555',
    padding: '10px',
    borderRadius: '5px',
    width: '100%',
    boxSizing: 'border-box'
};

const labelStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    // color: 'white',
    fontWeight: 'bold',
    fontSize: '14px',
    flex: 1
};

const rowStyle = {
    display: 'flex',
    gap: '20px',
    width: '100%',
    flexWrap: 'wrap'
};

const BookForm = () => {
    return (
        <form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    First Name *
                    <input type='text' style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Last Name *
                    <input type='text' style={inputStyle} required />
                </label>
            </div>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Company *
                    <input type='text' style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Title *
                    <input type='text' style={inputStyle} required />
                </label>
            </div>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Email *
                    <input type="email" style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Phone *
                    <input type="tel" style={inputStyle} required />
                </label>
            </div>
            <label style={labelStyle}>
                Which trainer are you interested in?
                <select type='text' style={inputStyle} required>
                    <option>Jahid Hasan</option>
                    <option>Other</option>
                </select>
            </label>
            <hr style={{ borderColor: '#444' }} />
            <h4>Event Details</h4>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Event Name
                    <input type='text' style={inputStyle} />
                </label>
                <label style={labelStyle}>
                    Event Date
                    <input type="date" style={inputStyle} />
                </label>
            </div>
            <label style={labelStyle}>
                Event Location *
                <input type='text' style={inputStyle} required />
            </label>
            <label style={labelStyle}>
                Event Budget
                <select type='text' style={inputStyle} defaultValue="">
                    <option value="" disabled>Select budget</option>
                    <option value="low">$0 - $100</option>
                    <option value="medium">$100 - $500</option>
                    <option value="high">$500 - $1000+</option>
                </select>
            </label>
            <label style={labelStyle}>
                Event Website Link
                <input type="text" style={inputStyle} />
            </label>
            <label style={labelStyle}>
                Additional Information
                <textarea style={{ ...inputStyle, height: '150px' }}></textarea>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input type="checkbox" />
                Yes, I’d like to receive updates
            </label>
            <button type="submit" className='btn-default'>
                Submit
            </button>
        </form>
    );
};

const BecomeForm = () => {
    return (
        <form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    First Name *
                    <input type='text' style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Last Name *
                    <input type='text' style={inputStyle} required />
                </label>
            </div>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Company *
                    <input type='text' style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Title *
                    <input type='text' style={inputStyle} required />
                </label>
            </div>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Email *
                    <input type="email" style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Phone *
                    <input type="tel" style={inputStyle} required />
                </label>
            </div>
            <label style={labelStyle}>
                Website or Social Link
                <input type="text" style={inputStyle} />
            </label>
            <label style={labelStyle}>
                Video Link
                <input type="text" style={inputStyle} />
            </label>
            <label style={labelStyle}>
            What are your current training fees?
                <input type="text" style={inputStyle} />
            </label>
            <label style={labelStyle}>
                Tell us about your training experience
                <textarea style={{ ...inputStyle, height: '250px' }}></textarea>
            </label>
            <label style={labelStyle}>
                Topics you train about
                <textarea style={{ ...inputStyle, height: '150px' }}></textarea>
            </label>
            <label style={labelStyle}>
                Why do you want to join us?
                <textarea style={{ ...inputStyle, height: '150px' }}></textarea>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input type="checkbox" />
                Yes, I’d like to receive updates
            </label>
            <button type="submit" className='btn-default'>
                Submit
            </button>
        </form>
    );
};

export default TrainingFormTabs;
